/* Smooth scrolling — Lenis init for the Las Alas theme.
   Self-hosted (assets/lenis.min.js exposes window.Lenis). Respects
   prefers-reduced-motion, offsets anchor jumps by the fixed header,
   and re-inits cleanly inside the Shopify theme editor. */
(function () {
  if (typeof window === 'undefined' || !window.Lenis) return;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  // Avoid double-init (e.g. script evaluated twice in the editor).
  if (window.lenis) return;

  var lenis = new Lenis({
    duration: 1.1,
    lerp: 0.1,
    smoothWheel: true,
    wheelMultiplier: 1,
    touchMultiplier: 1.6,
    easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }
  });
  window.lenis = lenis;

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  function headerOffset() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var n = parseFloat(v);
    return isNaN(n) ? 0 : n + 8;
  }

  // In-page anchor links → smooth scroll through Lenis, header-aware.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="#"]');
    if (!link) return;
    var url = link.getAttribute('href');
    // only same-page hash links
    if (url.charAt(0) !== '#') {
      var here = location.pathname + location.search;
      if (url.indexOf(here + '#') !== 0 && url.indexOf('#') !== 0) return;
    }
    var hash = url.slice(url.indexOf('#'));
    if (hash.length < 2) return;
    var target = document.querySelector(hash);
    if (!target) return;
    e.preventDefault();
    lenis.scrollTo(target, { offset: -headerOffset() });
    history.pushState(null, '', hash);
  });

  // Shopify theme editor: pause Lenis while the merchant interacts, and
  // keep it from fighting section re-renders.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { lenis.resize(); });
  }
})();
